import { ImportEntityType } from '../../../types/Import'
import { EntityTransformer, ValidationResult } from './types'
import { individualTransformer } from './individual'
import { committeeTransformer } from './committee'
import { companyTransformer } from './company'

// Transformer registry
const transformerRegistry: Record<ImportEntityType, EntityTransformer<unknown, unknown>> = {
  Individual: individualTransformer as EntityTransformer<unknown, unknown>,
  Committee: committeeTransformer as EntityTransformer<unknown, unknown>,
  Company: companyTransformer as EntityTransformer<unknown, unknown>
}

/**
 * Get the transformer for a specific entity type
 */
export function getTransformer (entityType: ImportEntityType): EntityTransformer<unknown, unknown> {
  return transformerRegistry[entityType]
}

/**
 * Transform raw import data to entity format using the appropriate transformer
 */
export function transformToEntity (
  raw: Record<string, unknown>,
  entityType: ImportEntityType
): Record<string, unknown> {
  const transformer = getTransformer(entityType)
  return transformer.toEntity(raw) as Record<string, unknown>
}

/**
 * Transform entity to form data using the appropriate transformer
 */
export function transformToFormData (
  entity: Record<string, unknown>,
  entityType: ImportEntityType
): Record<string, unknown> {
  const transformer = getTransformer(entityType)
  return transformer.toFormData(entity) as Record<string, unknown>
}

/**
 * Transform form data back to raw format using the appropriate transformer
 */
export function transformFromFormData (
  formData: Record<string, unknown>,
  entityType: ImportEntityType
): Record<string, unknown> {
  const transformer = getTransformer(entityType)
  return transformer.fromFormData(formData)
}

/**
 * Validate entity data using the appropriate transformer
 */
export function validateEntity (
  entity: Record<string, unknown>,
  entityType: ImportEntityType
): ValidationResult {
  const transformer = getTransformer(entityType)
  return transformer.validate(entity)
}
